module.exports = __webpack_public_path__ + "static/media/VICTORY4.718dc3e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY4.mp3
// module id = 304
// module chunks = 1 2 3